import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import * as jwt_decode from "jwt-decode";

import { globalConst } from "src/app/shared/helpers/constants";
import { User } from "src/app/shared/models/user.model";

@Injectable()
export class AuthService {
  loggedInEmitter = new EventEmitter<boolean>();

  constructor(private router: Router) {
    this.loggedInEmitter.emit(this.isLoggedIn());
  }

  logout() {
    localStorage.clear();
    this.loggedInEmitter.emit(this.isLoggedIn());
    this.router.navigate([globalConst.router.login], {
      skipLocationChange: false,
    });
  }

  isLoggedIn(): boolean {
    return (
      !!localStorage.getItem(globalConst.localStorage.tokenName) &&
      !this.isTokenExpired()
    );
  }

  getToken(): any {
    return localStorage.getItem(globalConst.localStorage.tokenName) || null;
  }

  getEnvironment(): any {
    return localStorage.getItem(globalConst.localStorage.environment)
      ? JSON.parse(
          atob(localStorage.getItem(globalConst.localStorage.environment))
        )
      : null;
  }

  getUserLogged(): User {
    try {
      return (
        (JSON.parse(
          localStorage.getItem(globalConst.localStorage.userLogged)
        ) as User) || {}
      );
    } catch (error) {
      return {};
    }
  }

  setUserLogged(data) {
    localStorage.setItem(
      globalConst.localStorage.environment,
      data.environment
    );
    localStorage.setItem(globalConst.localStorage.tokenName, data.token);
    localStorage.setItem(
      globalConst.localStorage.userLogged,
      JSON.stringify(data.user)
    );
    this.loggedInEmitter.emit(this.isLoggedIn());
  }

  removeToken() {
    localStorage.removeItem(globalConst.localStorage.tokenName);
    this.loggedInEmitter.emit(this.isLoggedIn());
  }

  getTokenExpirationDate(token: string): Date {
    const decoded = jwt_decode(token);
    if (decoded.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(decoded.exp);

    return date;
  }

  isTokenExpired(token?: string): boolean {
    try {
      if (!token) {
        token = this.getToken();
      }
      if (!token) {
        return true;
      }

      const expirationDate = this.getTokenExpirationDate(token);

      if (expirationDate === undefined) {
        return false;
      }
      return !(expirationDate.valueOf() > new Date().valueOf());
    } catch (error) {
      return true;
    }
  }
}
